export class SpectrumBin {
  freq: number;
  power: number;
}
